export function notify(message = '', options = {}) {
  const { title = '', type = 'info', duration = 4000 } = options;

  // Ensure container
  let container = document.getElementById('app-notify-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'app-notify-container';
    container.style.position = 'fixed';
    container.style.top = '20px';
    container.style.right = '20px';
    container.style.zIndex = 99999;
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.gap = '12px';
    document.body.appendChild(container);
  }

  const colors = {
    info: '#E6F4FF',
    success: '#ECFDF5',
    error: '#FEF2F2',
    warn: '#FFFBEB',
  };

  const borderColors = {
    info: '#60A5FA',
    success: '#10B981',
    error: '#EF4444',
    warn: '#F59E0B',
  };

  const toast = document.createElement('div');
  toast.style.minWidth = '240px';
  toast.style.maxWidth = '360px';
  toast.style.padding = '12px 14px';
  toast.style.borderRadius = '10px';
  toast.style.boxShadow = '0 6px 18px rgba(0,0,0,0.08)';
  toast.style.background = colors[type] || colors.info;
  toast.style.border = `1px solid ${borderColors[type] || borderColors.info}`;
  toast.style.color = '#0F172A';
  toast.style.fontFamily = 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial';

  const titleEl = document.createElement('div');
  titleEl.style.fontWeight = '700';
  titleEl.style.marginBottom = title ? '6px' : '0';
  titleEl.textContent = title;

  const msgEl = document.createElement('div');
  msgEl.style.fontSize = '14px';
  msgEl.textContent = message;

  if (title) toast.appendChild(titleEl);
  toast.appendChild(msgEl);

  container.appendChild(toast);

  setTimeout(() => {
    toast.style.transition = 'opacity 0.4s, transform 0.4s';
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(-10px)';
    setTimeout(() => container.removeChild(toast), 450);
  }, duration);
}

export default notify;
